import { PAGES } from '../lib/config';
import { QUALITY_FAQ } from '../lib/content';
import { ToolPageShell } from '../components/ToolPageShell';

export function EnlargeWithoutLosingQualityPage() {
  const page = PAGES.find((p) => p.path === '/enlarge-image-without-losing-quality')!;
  const extra = (
    <>
      <h2 className="text-2xl font-bold text-text-primary">Enlarge images without losing quality</h2>
      <p>
        AI upscaling can help preserve quality when you enlarge an image. It uses machine learning to
        predict details instead of just stretching pixels.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">Important caveat</h3>
      <p>
        No tool can create real detail that was never captured. AI can improve the appearance, but
        a true high-resolution source will always look better.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">How to maximize quality</h3>
      <ul>
        <li>Start with the highest-resolution original</li>
        <li>Avoid heavy compression before upscaling</li>
        <li>Use 2× for safety; use 4× only when you need large output</li>
      </ul>
      <p>Try it free for up to 2 images per day.</p>
    </>
  );
  return <ToolPageShell page={page} faqItems={QUALITY_FAQ} extraContent={extra} />;
}
